__turbopack_context__.v({
  "loading-block": "loading-module-scss-module__VwKmbq__loading-block",
  "loading-container": "loading-module-scss-module__VwKmbq__loading-container",
  "spin": "loading-module-scss-module__VwKmbq__spin",
  "spinner": "loading-module-scss-module__VwKmbq__spinner",
});
